import React, { useEffect, useState } from "react";
import {
    PostClosedAtDateSpan,
    PostClosedAtTypography,
} from "./PostPollClosedAt.styles";
import { usePollIsOpenState } from "./usePollIsOpenState";

export const QUIZ_CLOSED_MESSAGE = "Quiz wurde durch den Autor beendet.";
const POLL_CLOSED_MESSAGE = "Umfrage wurde durch den Autor beendet.";

export function PostPollClosedAt({
    pollClosedAt,
    closedMessage = POLL_CLOSED_MESSAGE,
}: {
    pollClosedAt: string | undefined;
    closedMessage?: string;
}) {
    const { open, timeLeft, units } = usePollIsOpenState(pollClosedAt);

    const [timeLeftText, setTimeLeftText] = useState<string>();

    useEffect(() => {
        if (!open) {
            setTimeLeftText(closedMessage);
            return;
        }
        let timeLeftText;
        if (units === "d") {
            if (timeLeft && timeLeft > 1) {
                timeLeftText = `${timeLeft} Tage`;
            } else {
                timeLeftText = `${timeLeft} Tag`;
            }
        } else if (units === "h") {
            if (timeLeft && timeLeft > 1) {
                timeLeftText = `${timeLeft} Stunden`;
            } else {
                timeLeftText = `${timeLeft} Stunde`;
            }
        } else if (units === "m") {
            if (timeLeft && timeLeft > 1) {
                timeLeftText = `${timeLeft} Minuten`;
            } else {
                timeLeftText = `${timeLeft} Minute`;
            }
        } else if (units === "s" && timeLeft && timeLeft > 1) {
            timeLeftText = `${timeLeft} Sekunden`;
        } else {
            timeLeftText = `1 Sekunde`;
        }
        setTimeLeftText(timeLeftText);
    }, [open, timeLeft, units]);

    if (!pollClosedAt) {
        return <></>;
    }

    return (
        <>
            {!open && (
                <PostClosedAtTypography>{timeLeftText}</PostClosedAtTypography>
            )}
            {open && timeLeftText && (
                <PostClosedAtTypography>
                    Umfrage läuft noch{" "}
                    <PostClosedAtDateSpan component={"span"}>
                        {timeLeftText}
                    </PostClosedAtDateSpan>
                    .
                </PostClosedAtTypography>
            )}
        </>
    );
}
